import React, { Component } from 'react'
import _ from "lodash"
import PropTypes from 'prop-types'

import QuestionForm from './_components/Questions/QuestionForm'
import EadRequests from "../../../../requests/ead-requests"
import { QuestionTypeEnum } from "../../../../enums/QuestionTypeEnum"
import Questionary from './_components/Questionary'
import DefautQuestionaryInfoCard from './_components/DefautQuestionaryInfoCard'
import QuestionarySummary from './_components/QuestionarySummary'
import { StyledQuestionAnswers, StyledCommentBox } from './styled/StyledQuestionComponents'
import PreviousTriesSummary from './_components/PreviousTriesSummary'
import ModalAlertTimeIsOver from './_components/ModalAlertTimeIsOver'
import ModalConfirmSendAnswers from './_components/ModalConfirmSendAnswers'
import LoadingOverlay from './_components/LoadingOverlay'

class QuestionaryMainContainer extends Component {
    constructor (props) {
        super(props)
        this.state = {
            currentQuestionNumber: 0,
            disabledButton: true,
            questionsAnswers: {},
            currentAnswer: null,
            form: {},
            questionaryOn: false,
            summaryOn: false,
            reviewOn: false,
            isSaved: true,
            questionsSaved: {},
            showConfirmModal: false,
            showFinishModal: false,
            loading: false,
            clearPrevTriesSummary: false
        }
        this.handleQuestionNavigation = this.handleQuestionNavigation.bind(this)
        this.returnFromSummaryToNavigation = this.returnFromSummaryToNavigation.bind(this)
        this.onFormStateChange = this.onFormStateChange.bind(this)
        this.showQuestion = this.showQuestion.bind(this)
        this.startQuestionary = this.startQuestionary.bind(this)
        this.saveQuestion = this.saveQuestion.bind(this)
        this.showSummary = this.showSummary.bind(this)
        this.sendAnswers = this.sendAnswers.bind(this)
        this.setTimer = this.setTimer.bind(this)
        this.tick = this.tick.bind(this)
        this.closeConfirmModal = this.closeConfirmModal.bind(this)
        this.closeFinishModal = this.closeFinishModal.bind(this)
        this.setLoading = this.setLoading.bind(this)

    }

    componentDidUpdate(prevProps) {
        if (this.props.form.code !== prevProps.form.code) {
            this.init()
            this.getPreviousTriesData()
        }
    }

    componentWillUnmount() {
        this.setState({
            showConfirmModal: true,
        })
    }

    async componentDidMount() {
        this.init()
        this.getPreviousTriesData()


        if (!!this.loadState()) {
            this.setState({
                intervalHandle: setInterval(this.tick, 1000)
            }, () => {
                this.setState(this.loadState())
            })
        }
    }

    init() {

        if (!this.props.context.eadAnswers)
            this.props.context.set({ eadAnswers: {} })


        this.setState({
            questions: null,
            formValue: null,
            maxTries: null,
            form: {},
            hasAnswers: false,
            submitLoading: false
        }, async () => {
            await this.setDataToBuildForm()
        })
    }

    /** Salva state atual no localStorage */
    saveState() {
        localStorage.setItem('questionaryState', JSON.stringify(this.state))
    }

    /** Carrega state salvo no localStorage */
    loadState() {
        return JSON.parse(localStorage.getItem('questionaryState'))
    }

    /** Remove state salvo no localStorage */
    removeSavedState() {
        localStorage.removeItem('questionaryState')
    }

    /** Define dados para montagem do questionario (distingue formualario respondido / nao-respondido). */
    async setDataToBuildForm() {

        this.setDataToBuildUnansweredForm()

    }

    /** Define dados para montagem do questionario que ainda nao foi respondido. */
    setDataToBuildUnansweredForm() {

        const {
            numQuestions,
            maxTries,
            random,
            questionDTOs
        } = this.props.form


        // Define lista de questoes
        let questions = []

        if (random) {

            const alreadyIn = []

            for (let i = 0;i < numQuestions;i++) {

                let index = Math.floor(Math.random() * numQuestions)

                while (alreadyIn.includes(index)) {
                    index = Math.floor(Math.random() * numQuestions)
                }

                questions.push(questionDTOs[index])
                alreadyIn.push(index)
            }


        } else {
            questions = questionDTOs.sort((a, b) => a.order < b.order ? -1 : 1)
        }

        let currentTry = null

        if (maxTries) {
            const tries = this.state.tries || 0
            currentTry = tries + 1
        }

        // Define valor do form
        const formValue = questions
            .map(question => question.value)
            .reduce((total, next) => (total + next), 0)


        this.setState({
            questions: null,
            formValue: null,
            maxTries: null,
            hasAnswers: false
        }, () => {
            this.setState({ questions, formValue, maxTries, hasAnswers: false, currentTry })
        })
    }

    groupBy(list, keyGetter) {
        const map = new Map()
        list.forEach((item) => {
            const key = keyGetter(item)
            const collection = map.get(key)
            if (!collection) {
                map.set(key, [item])
            } else {
                collection.push(item)
            }
        })
        return map
    }


    setTimer() {
        const timeLimit = this.props.form.timeLimit

        if (!timeLimit) return

        this.setState({
            seconds: 0,
            minutes: timeLimit,
            secondsRemaining: timeLimit * 60,
            intervalHandle: setInterval(this.tick, 1000)
        })

    }

    tick() {

        let { minutes, seconds, secondsRemaining, intervalHandle, questionaryOn, isReview } = this.state
        secondsRemaining--
        minutes = Math.floor(this.state.secondsRemaining / 60)
        seconds = this.state.secondsRemaining % 60


        if (questionaryOn && this.state.minutes === 0 && this.state.seconds === 0) {
            this.setState({
                showConfirmModal: true,
            }, () => {
                this.sendAnswers()
                    .then(() => {
                        this.setState({
                            questionaryOn: false,
                            reviewOn: false,
                            questionsAnswers: {},
                            questionsSaved: {},
                            currentQuestionNumber: 0,
                            showConfirmModal: false
                        })
                        this.getPreviousTriesData(false)
                        this.props.updateSlaveAction(false)
                    })
            })
            return
        }

        this.setState({
            minutes,
            seconds,
            secondsRemaining
        })

        // Salva state no localStorage a cada 5 segundos
        if (secondsRemaining % 5 === 0) {

            this.saveState()
        }
    }

    //* Busca dados das tentativas anteriores */
    async getPreviousTriesData(review) {

        const { form, eadUser } = this.props
        const filter = {
            frmCode: form.code,
            usrCode: eadUser.code,
        }
        this.setState({ loading: true })

        await EadRequests.searchUserForms(filter)
            .then(result => { this.setState({ userForm: result, loading: true }) })
            .catch(e => { this.setState({ loading: false }) })

        const formAnswers = await this.searchFormAnswers()
        const previousTriesData = this.state.userForm.userform

        let { questionsAnswers, questionsSaved } = this.state

        if (!!review) {
            questionsAnswers = {}
            questionsSaved = {}
            formAnswers.forEach(ans => {
                questionsAnswers[ans.questionDTO.code] = +ans.answer
                questionsSaved[ans.questionDTO.code] = ans.flagged
            })
        }

        this.setState({
            previousTriesDTO: previousTriesData,
            lastTryAnswers: formAnswers,
            questionsAnswers,
            questionsSaved,
            loading: false,
        })
    }

    /** Busca & retorna respostas para questoes do formulario atual (se houver). */
    async searchFormAnswers() {

        const { form, eadUser } = this.props

        const searchParams = {
            frmCode: form.code,
            usrCode: eadUser.code,
        }

        const reqResult = await EadRequests.searchUserAnswers(searchParams)

        return reqResult.useranswer || null
    }

    getNotTrueOfFalseAnswersList = (questionCodes, formValues) => {
        const { form, eadUser } = this.props
        const notTrueOrFalseAnswersList = []

        questionCodes.forEach(questionCode => {

            questionCode = parseInt(questionCode)
            const formFieldValue = formValues[questionCode]
            const question = this.state.questions.filter(question => (question.code === questionCode))[0]
            const flagged = this.state.questionsSaved[question.code] ? this.state.questionsSaved[question.code] : false

            if (question.type !== QuestionTypeEnum.TRUE_OR_FALSE) {

                const returnObj = {
                    formDTO: form,
                    userDTO: eadUser,
                    questionDTO: question,
                    answer: formFieldValue,
                    flagged: flagged,
                }

                if (question.type == QuestionTypeEnum.ONE_ANSWER) {
                    returnObj.optionDTO = question.optionDTOs.filter(option => (option.code === formFieldValue))[0]
                }

                notTrueOrFalseAnswersList.push(returnObj)
            }
        })

        return notTrueOrFalseAnswersList
    }

    /** Envia respostas do questionario para api. */
    submitForm = async () => {

        //Remove state do localStorage
        this.removeSavedState()

        this.setState({
            submitLoading: true
        })


        const formValues = this.state.questionsAnswers
        const { form, eadUser } = this.props


        // Prepara lista de respostas
        // const questionCodes = Object.keys(formValues)
        const questionCodes = this.state.questions.map(que => que.code)
        const timeSpent = !!this.props.form.timeLimit ? this.props.form.timeLimit - this.state.minutes : null
        const userAnswerDTOList = this.getNotTrueOfFalseAnswersList(questionCodes, formValues)


        const reqResult = await EadRequests.saveUserAnswers(userAnswerDTOList)


        if (reqResult.success) {
            const res = await EadRequests.consolidateFormData({
                frmCode: form.code,
                usrCode: eadUser.code,
                timeSpent: timeSpent
            })

            this.props.onQuestionAnswersSent()

            this.props.context.set({
                eadAnswers: {
                    ...this.props.context.eadAnswers,
                    [form.code]: {
                        grade: res.grade,
                        best: res.best,
                    }
                }
            })


            const elemDOM = document.querySelector('.master')
            elemDOM.scrollTop = 0

            this.props.context.set({
                toastMessage: {
                    type: 'success',
                    content: "Questionário enviado com sucesso!"
                }
            })
        }
        this.setState({
            hasAnswers: true,
            tries: (this.state.tries || 0) + 1,
            submitLoading: false
        })
    }


    startQuestionary(review = false, slaveAction = true) {
        this.props.updateSlaveAction(slaveAction)
        this.setState({
            questionaryOn: !this.state.questionaryOn,
            reviewOn: review,
            questionsAnswers: {},
            questionsSaved: {},
            currentQuestionNumber: 0
        })
        this.getPreviousTriesData(review)
        if (!this.state.questionaryOn && !review) {
            this.setTimer()
        }
    }

    // exibe tela de resumo da tentativa atual
    showSummary() {
        this.setState({
            summaryOn: !this.state.summaryOn,
        })
    }

    // exibe tela de revisão e chama método que envia respostas para api
    sendAnswers() {

        return this.submitForm().then(() => {
            this.setState({
                summaryOn: false,
                reviewOn: false,
                currentQuestionNumber: 0,
            })
            this.closeFinishModal()
            this.startQuestionary(false, false)
            clearInterval(this.state.intervalHandle)
        })
    }

    showQuestion(questions) {

        const currentQuestion = questions[this.state.currentQuestionNumber]
        const answer = this.state.questionsAnswers ? this.state.questionsAnswers[currentQuestion.code] : null
        const isReview = this.state.reviewOn
        const question = { ...currentQuestion, answer, isReview }
        const options = currentQuestion && currentQuestion.optionDTOs
        const correctAnswerCode = _.find(options, opt => opt.isCorrectAnswer).code

        return (
            <div>
                <h1>{this.state.currentQuestionNumber + 1}. {currentQuestion.title}</h1>
                { // Se for revisão e se a questão tiver comentário
                    isReview && currentQuestion.comment != null ?
                        <StyledCommentBox> {currentQuestion.comment} </StyledCommentBox>
                        :
                        ''
                }

                {
                    currentQuestion.description !== null &&
                    <div className={'question-description'}
                        dangerouslySetInnerHTML={{ __html: `${_.get(currentQuestion, 'description')}` }} />
                }

                {
                    isReview && currentQuestion.type !== 3 ? // caso seja tela de revisão 
                        options.map((item, key) => {


                            const isCorrect = item.code === correctAnswerCode
                            const isAnswer = item.code === answer

                            return (
                                <React.Fragment>
                                    <StyledQuestionAnswers isCorrect={isCorrect} isAnswer={isAnswer}>
                                        {item.text}
                                    </StyledQuestionAnswers>
                                    {isReview && item.comment != null ?
                                        <StyledCommentBox style={{ marginTop: '10px', marginLeft: '20px', borderColor: '#DDDDDD', background: '#EEEEEE' }}>
                                            <b>Comentário:</b> <br />
                                            {item.comment}
                                        </StyledCommentBox>
                                        : ''}
                                </React.Fragment>
                            )

                        })

                        :
                        <QuestionForm {...question} />
                }
            </div>
        )
    }

    onFormStateChange = (form) => {
        this.setState({
            form
        })

        this.saveState()
    }

    // cria uma lista questoes marcadas como salvas [questionCode]=true/false
    saveQuestion(questionCode) {
        this.setState({
            isSaved: !this.state.isSaved,
        })
        const { questionsSaved, isSaved } = this.state
        questionsSaved[questionCode] = isSaved
        this.setState({
            questionsSaved
        })

    }


    handleQuestionNavigation(questionNumber) {
        const { questions, reviewOn, currentQuestionNumber, questionsAnswers, form } = this.state

        if (reviewOn) {
            questionNumber = questionNumber < 0 ? questions.length - 1 : questionNumber

            this.setState({
                currentQuestionNumber: (questionNumber % questions.length),
                disabledButton: questionNumber === 0,
            })
            return
        }

        const question = questions[currentQuestionNumber]
        questionsAnswers[question.code] = form.values[question.code]

        if (questionNumber < 0) return

        if (questionNumber < questions.length) {
            this.setState({
                currentQuestionNumber: questionNumber,
                disabledButton: questionNumber === 0,
                questionsAnswers,
            })
        } else {
            this.setState({showFinishModal: true})
        }
    }

    returnFromSummaryToNavigation(questionNumber) {
        this.setState({
            currentQuestionNumber: questionNumber,
            disabledButton: questionNumber === 0,
            summaryOn: false,
        })
    }

    setLoading() {
        this.setState({ loading: false })
    }

    closeConfirmModal() {
        this.setState({ showConfirmModal: false })
    }

    closeFinishModal() {
        this.setState({ showFinishModal: false })
    }

    render() {


        const {
            form,
            currentQuestionNumber,
            questionaryOn,
            questionsAnswers,
            questionsSaved,
            summaryOn,
            reviewOn,
            previousTriesDTO,
            lastTryAnswers,
        } = this.state

        let {
            questions
        } = this.state

        questions = (questions === null && !!this.loadState()) ? this.loadState()['questions'] : questions

        return (
            <div>
                {
                    questionaryOn ?
                        summaryOn ?
                            <QuestionarySummary
                                questions={questions}
                                answers={questionsAnswers && questionsAnswers}
                                savedQuestions={questionsSaved}
                                startQuestionary={this.startQuestionary}
                                questionaryInfo={this.props.form}
                                showSummary={this.showSummary}
                                sendAnswers={this.sendAnswers}
                                minutes={this.state.minutes}
                                seconds={this.state.seconds}
                                hasTime={!!this.props.form.timeLimit}
                                returnToQuestionNavigation={this.returnFromSummaryToNavigation}
                            />
                            :
                            <Questionary
                                hasTime={!!this.props.form.timeLimit}
                                questions={questions}
                                form={form}
                                questionsAnswers={questionsAnswers}
                                currentQuestionNumber={currentQuestionNumber}
                                showQuestion={this.showQuestion}
                                onFormStateChange={this.onFormStateChange}
                                handleQuestionNavigation={this.handleQuestionNavigation}
                                disabledButton={this.state.disabledButton}
                                saveQuestion={this.saveQuestion}
                                savedQuestions={questionsSaved}
                                showSummary={this.showSummary}
                                showDefautPage={this.startQuestionary}
                                isReview={reviewOn}
                                questionaryInfo={this.props.form}
                                minutes={this.state.minutes}
                                seconds={this.state.seconds}
                                previousTriesDTO={previousTriesDTO}
                            />
                        :
                        <div>
                            <DefautQuestionaryInfoCard
                                startQuestionary={this.startQuestionary}
                                questionaryInfo={this.props.form}
                                previousTriesDTO={previousTriesDTO}
                                loading={this.setLoading}
                            />
                            {
                                previousTriesDTO &&
                                previousTriesDTO.length > 0 &&

                                <PreviousTriesSummary
                                    previousTriesDTO={previousTriesDTO}
                                    lastTryAnswers={lastTryAnswers}
                                    reviewOn={this.startQuestionary}
                                    formCode={this.props.form.code}
                                    hasTime={!!this.props.form.timeLimit}
                                    loading={this.setLoading}
                                />
                            }

                        </div>



                }

                <ModalConfirmSendAnswers
                    showConfirmModal={this.state.showFinishModal}
                    closeConfirmModal={this.closeFinishModal}
                    sendAnswers={this.sendAnswers}
                />

                <ModalAlertTimeIsOver
                    showConfirmModal={this.state.showConfirmModal}
                    closeConfirmModal={this.closeConfirmModal}
                />
                <LoadingOverlay show={this.state.loading} />
            </div>
        )
    }
}

export default QuestionaryMainContainer

QuestionaryMainContainer.propTypes = {
    form: PropTypes.object.isRequired,
    eadUser: PropTypes.object.isRequired,
    onQuestionAnswersSent: PropTypes.func.isRequired,
    currentQuestionNumber: PropTypes.number,
    disabledButton: PropTypes.bool,
    questionsAnswers: PropTypes.object,
    currentAnswer: PropTypes.object
}

QuestionaryMainContainer.defaultProps = {}



// WEBPACK FOOTER //
// ./src/components/_ead/_contentTypes/QuestionsNew/QuestionaryMainContainer.js